import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Question } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface AddQuestionState {
  content: string;
  questions: Question[];
}

// Define the initial state using that type
const initialState: AddQuestionState = {
  content: "",
  questions: [],
};

export const addQuestionSlice = createSlice({
  name: "addQuestion",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setContent: (state, action: PayloadAction<string>) => {
      state.content = action.payload;
    },
    setQuestions: (state, action: PayloadAction<Question[]>) => {
      state.questions = action.payload;
    },
  },
});

export const { setContent, setQuestions } = addQuestionSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getAddQuestionData = (state: RootState) => state.addQuestion;
export default addQuestionSlice.reducer;
